import { Component, inject } from '@angular/core';

import { of } from 'rxjs';

import {
  AgGridComponent,
  AgGridEditabledComponent,
  CamGridDataService,
  FieldsSelectionComponent,
  GridControlComponent,
  GridMetaData,
  PaginationComponent,
  ParameterType,
} from '@camelot/core';

import { TestIdDirective } from '@camelot/testing-harness';

interface BehaviorRow {
  active: boolean;
  amount: number;
  count: number;
  id: string;
  name: string;
  when: string;
}

const ROWS: BehaviorRow[] = [
  { active: true, amount: 1234.5, count: 7, id: '1', name: 'Zeta', when: '2026-03-15T10:30:00Z' },
  { active: false, amount: 42, count: 3, id: '2', name: 'Alpha', when: '2026-01-02T08:00:00Z' },
];

@Component({
    imports: [
        AgGridComponent,
        AgGridEditabledComponent,
        FieldsSelectionComponent,
        GridControlComponent,
        PaginationComponent,
        TestIdDirective,
    ],
    template: `
    <cam-grid-control camTestId="gb-control" [gridId]="this.gridId" />
    <cam-fields-selection camTestId="gb-fields" [gridId]="this.gridId" />
    <cam-ag-grid
      camTestId="gb-grid"
      [gridId]="this.gridId"
      [colsMetaData]="this.colsMetaData"
      [data]="this.rows"
      defaultDisplay="grid"
    />
    <cam-ag-grid-editabled
      camTestId="gb-editable"
      [gridId]="this.editableGridId"
      [colsMetaData]="this.editableCols"
      [services]="this.editableServices"
    />
    <cam-ag-grid
      camTestId="gb-paginated"
      [gridId]="this.paginatedGridId"
      [colsMetaData]="this.paginatedCols"
      [data]="this.paginatedRows"
      defaultDisplay="grid"
    />
    <cam-grid-pagination camTestId="gb-pagination" [gridId]="this.paginatedGridId" />
  `
})
export class GridBehaviorCase {
  public colsMetaData: GridMetaData[] = [
    { name: 'name', shownByDefault: true, type: ParameterType.String },
    { name: 'active', shownByDefault: true, type: ParameterType.Boolean },
    { name: 'amount', shownByDefault: true, type: ParameterType.Currency },
    { name: 'count', shownByDefault: true, type: ParameterType.Number },
    { name: 'when', shownByDefault: true, type: ParameterType.DateTime },
  ];
  public editableCols: GridMetaData[] = [
    { name: 'name', shownByDefault: true, type: ParameterType.String },
    { name: 'count', shownByDefault: true, type: ParameterType.Number },
  ];
  public editableGridId = 'e2e-grid-behavior-editable';
  public editableServices = {
    getData$: () => of({ items: ROWS }),
  } as never;
  public gridId = 'e2e-grid-behavior';
  public paginatedCols: GridMetaData[] = [{ name: 'name', shownByDefault: true, type: ParameterType.String }];
  public paginatedGridId = 'e2e-grid-behavior-paginated';
  public paginatedRows = Array.from({ length: 60 }, (_, index) => ({
    id: `row-${index + 1}`,
    name: `Row-${String(index + 1).padStart(2, '0')}`,
  }));
  public rows = ROWS;

  private readonly _dataService = inject(CamGridDataService);

  ngOnInit(): void {
    this._dataService.get(this.gridId, true).switchView('grid');
    this._dataService.get(this.editableGridId, true).switchView('grid');
    this._dataService.get(this.paginatedGridId, true).switchView('grid');
  }
}
